module.exports = __webpack_public_path__ + "assets/img/benefit-1.1b3498a3.svg";